export const trabajos = [
    {
        'id': 'Mispelisymisseries',
        'nombre': 'Mis películas y mis series',
        'url': 'https://danielurbanoluna.github.io/06_proyecto_pelis/build/',
        'tecnologias': 'REACT, HTML, CSS, JavaScript',
        'categorias': 'Desarrollo web',
        'descripcion': 'Descripción más detallada del proyecto'
    },
    {
        'id': 'piedrapapeltijera',
        'nombre': 'Juego de piedra papel tijera',
        'url': 'https://danielurbanoluna.github.io/piedrapapeltijera/build/',
        'tecnologias': 'REACT, HTML, CSS, JavaScript',
        'categorias': 'Desarrollo web',
        'descripcion': 'Descripción más detallada del proyecto'
    },
    {
        'id': 'champus',
        'nombre': 'Champus segun tu tipo de cabello',
        'url': 'https://champu.net/',
        'tecnologias': 'wordpress',
        'categorias': 'Desarrollo web',
        'descripcion': 'Descripción más detallada del proyecto'
    },
    
];